import React, { useEffect, useState } from "react";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
// import "primeicons/primeicons.css";
import "./App.scss";
import AppRoutes from "./routes";
import { ToastContainer } from "react-toastify";
import Loader from "./components/common/loader";
import { refreshTokenAPI } from "./helpers/utils";
import { useAuth0 } from "@auth0/auth0-react";
import { useAuthStore, useSettingStore } from "./redux/auth-store";
import "react-toastify/dist/ReactToastify.css";
import { getMasterEnvironment } from "./services/common.service";

function App() {
  const { user: authUser, token, setUser, setToken } = useAuthStore();
  const { setSettings } = useSettingStore();
  const [mounted, setMounted] = useState<boolean>(false);
  // const { user, isAuthenticated, isLoading, error } = useAuth0();
  const themeMode = "light";

  useEffect(() => {
    document.documentElement.dataset.bsTheme = themeMode;
  }, [themeMode]);

  useEffect(() => {
    if (authUser) {
      setToken("true");
      setUser(authUser);
    }
    // console.log("token = ",token, authUser)
    // logout({ logoutParams: { returnTo: window.location.origin } })
  }, [authUser]);

  /**
   * On load set app mounted
   */
  useEffect(() => {
    setMounted(true);
    /**
     * This script sets up an interval to call the refreshTokenAPI() function at regular intervals.
     * The interval duration is determined by the REACT_APP_REFRESH_TOKEN_MINUTE environment variable.
     */
    // Calculate the time interval in milliseconds
    const time = 1000 * 60 * Number(process.env.REACT_APP_REFRESH_TOKEN_MINUTE);
    const interval = setInterval(() => {
      refreshTokenAPI();
    }, time);
    return () => {
      clearInterval(interval);
    };
  }, []);

  /**
   * Once the app is mounted then
   * get configs for the app.
   */
  useEffect(() => {
    if (mounted) {
      getConfigs();
    }
  }, [mounted]);

  /**
   * Retrieves configurations and sets them using dispatch.
   * @returns {void}
   */
  const getConfigs = () => {
    getMasterEnvironment().then(
      (res: any) => {
        const { data } = res;
        if (data && Object.keys(res.data).length) {
          setSettings(res.data);
        }
      },
      (err) => {
        console.log(err);
      },
    );
  };

  // if (!token) {
  //   return <Loader isLoading={true} />;
  // }

  return (
    <React.Suspense fallback={<Loader isLoading={true} />}>
      <AppRoutes />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </React.Suspense>
  );
}

export default App;
